import { FC } from 'react';
import { Location, Navigate, Outlet, useLocation } from 'react-router-dom';
import { User } from '../../utils/models';

import auth from '../../services/authService';
import routes from '../../utils/routes';

const ProtectedRoute: FC = (): JSX.Element => {
	const location: Location = useLocation();
	const user: User | null = auth.getCurrentUser();

	return user ? (
		<Outlet />
	) : (
		<Navigate to={routes.login.pathname} state={{ from: location.pathname }} />
	);
};

export default ProtectedRoute;
